import React, {useEffect, useReducer, useState} from "react";
import KullOppdretter from "../components/KullOppdretter";
import {getKullOppdretter, getOppdretterProfilBilde} from "../api";
import {withRouter} from "react-router-dom";


const KullOppdretterContainer = (props) => {
    const { id } = props.match.params;
    const {hund} = props;
    const {kullOppdretter} = useFetchKullOppdretter(hund.hundId, id);
    const [count, forceUpdate] = useReducer(x => x + 1, 0);
    const personId = props.personId;
    const {bilde} = useFetchOppdretterProfilBilde(hund.hundId, id, hund.ikkeVisOppdretterProfilData, count);


    const reloadBilde = () => {
        forceUpdate();
    };
    return (
        <KullOppdretter hund={hund} kullOppdretter={kullOppdretter} profilBilde={bilde} personId={personId} reloadBilde={reloadBilde} />
    );
};

const useFetchKullOppdretter = (hundId, id) => {
    const [kullOppdretter, setKullOppdretter] = useState(null);
    const [isKullOppdretterLoading, setIsKullOppdretterLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsKullOppdretterLoading(true);
            }
            getKullOppdretter(hundId, id)
                .then((data) => {
                    if (isMounted) {
                        setKullOppdretter(data);
                        setIsKullOppdretterLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsKullOppdretterLoading(false);
                        setKullOppdretter(null);
                    }
                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [hundId, id]);
    return { kullOppdretter, isKullOppdretterLoading };
};


const useFetchOppdretterProfilBilde = (hundId, id, ikkeVisOppdretterProfilData, count) => {
    const [bilde, setBilde] = useState(null);
    const [isBildeLoading, setIsBildeLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (ikkeVisOppdretterProfilData === false) {
                if (isMounted) {
                    setIsBildeLoading(true);
                }
                getOppdretterProfilBilde(hundId, id)
                    .then((bilde) => {
                        if (isMounted) {

                            setBilde(bilde);
                            setIsBildeLoading(false);
                        }
                    })
                    .catch((err)=> {
                        if (isMounted) {
                            setBilde(null);
                            setIsBildeLoading(false);
                        }
                    });
            } else {
                if (isMounted) {
                    setBilde(null);
                    setIsBildeLoading(false);
                }
            }
        };
        if (id !== null) {
            fetchData();
        }

        return () => {
            isMounted = false;
        };
    }, [hundId, id, ikkeVisOppdretterProfilData, count]);

    return { bilde, isBildeLoading };
}

export default withRouter(KullOppdretterContainer);
